export { AddOrReplacePatchComponent } from './add-or-replace-patch.component';
